<template>  
    <div id="genesis-menu" class="custom-scroller" :class="{ 'active' : $store.state.navStates.isGenesisNavOpen }">
      <div class="closer"><img src="~@/assets/icons/close-x.svg" alt=""  @click.stop="hideMenu" /></div>
        <ul>
            <li v-for="l0Item in level0" :key="l0Item.id" @click.stop="loadGenitem(l0Item)" class="first" :class="{selected:l0Item.herf == $store.state.activeTexts.actBookTarget}" >                   
                <span class="title"  v-html="l0Item.text" ></span>
                <div class="mobile-nav-toggle" v-if="l0Item.class==='sub'" @click.stop="l0Item.isShow = !l0Item.isShow" ><i class="zf zf-chevron-right" :class="{active:l0Item.isShow}"></i></div>
                <transition name="slide">
                <ul  class="child" v-if="l0Item.isShow">
                    <li v-for="l1Item in l0Item.level1" :key="l1Item.id" @click.stop="loadGenitem(l1Item )" :class="{selected:l1Item.path == $store.state.activeTexts.actBookTarget}" >                            
                        <span class="menuitem" v-html="l1Item.text" ></span><!--<span v-html="l1Item.text" ></span>-->
                         
                    </li>
                </ul> 
                </transition >                            
            </li>
        </ul>
    </div>
</template>

<script>

    export default {
        name: "GeneseMenu",
            data() {
                return {
                  actMenuItem: "",
                  level0: [
                    {
                      "id": "chrontxtz",
                      "path": "chrontxtz",                      
                      "isShow": false,
                      "text": "Textzeugenliste"
                    },
                    {
                      "id": "chronik",
                      "path": "chronikluw",                      
                      "isShow": false,
                      "text": "Chronik zu Leben und Werk"
                    },  
                    {
                      "id": "segmentierungen",
                      "path": "segmentierungen",   
                      "class": "sub",                   
                      "isShow": false,
                      "text": "Segmentierungen",
                      "level1": [
                        {
                          "id": "seg-labyrinth",
                          "path": "seglabyrinth",
                          "text": "<em>Stoffe I - III / Labyrinth</em>"
                        },   
                        {
                          "id": "seg-turmbau",
                          "path": "segturmbau",
                          "text": "<em>Turmbau</em>"
                        },  
                        {
                          "id": "seg-gedankenfuge",
                          "path": "seggedankenfuge",
                          "text": "<em>Gedankenfuge</em>"
                        },
                        {
                          "id": "seg-vallon",
                          "path": "segvallon",
                          "text": "<em>Vallon de l'Ermitage</em>"
                        }                                                                                             
                      ]
                    },                                          
                    {
                      "id": "stemmataintro",
                      "path": "stemmataintro",
                      "class": "sub",
                      "isShow": false,
                      "text": "Stemmata",
                      "level1": [
                        /*
                        {
                          "id": "duerrenmatt1981",
                          "json": "dummy-jsonfile.json",
                          "image" : "07106_1_Duerrenmatt_Stemmata_approved.v7-1.png",
                          "path": "stemmata",
                          "text": "Stemma Dürrenmatt 1981 "
                        },
                        {
                          "id": "duerrenmatt1983",
                          "json": "dummy-jsonfile.json",
                          "image" : "07106_1_Duerrenmatt_Stemmata_approved.v7-1.png",
                          "path": "stemmata",
                          "text": "Stemma Dürrenmatt 1983 "
                        },*/
                        {
                          "id": "survey1964-1981",
                          "json": "stemma-1964-81.json",
                          "image" : "Stemma1964-81.png",
                          "path": "stemmata",
                          "text": "Übersichts-Stemma 1964-1981"
                        },
                        {
                          "id": "survey1981-1990",
                          "json": "stemma-1981-90.json",
                          "image" : "Stemma1981-90.png",
                          "path": "stemmata",
                          "text": "Übersichts-Stemma 1981-1990"
                        },
                        {
                          "id": "mondfinsternis",
                          "json": "mondfinsternis.json",
                          "image" : "StemmaMondfinsternis.png",
                          "path": "stemmata",
                          "text": "Detailstemma <i>Mondfinsternis</i>"
                        },
                        {
                          "id": "der-tod-des-sokrates",
                          "json": "Genese2.json",
                          "image" : "Genese2.png",
                          "path": "stemmata",
                          "text": "Einzelblatt-Stemma <i>Der Tod des Sokrates</i>"
                        }/*,
                        {
                          "href": "2-4",
                          "text": "Metamorphosen der Metaphern"
                        },
                        {
                          "href": "2-4",
                          "text": "Entwicklung Labyrinthmotiv"
                        },
                        {
                          "href": "2-4",
                          "text": "Rekonstruktion Erzählung <i>Der Winterkrieg in Tibet</i>"
                        }*/
                      ]
                    },
                    {
                      "id": "timeline",
                      "path": "timeline",                      
                      "isShow": false,
                      "text": "Timeline"
                    }
                  ]
                }

            },

	methods:{
      hideMenu() {
          this.$store.commit('changeArchiveNavState', {'active': false, 'type': 'Genese'} ) 
      },
      loadGenitem: function(item) { 
          if(item.path == ""){item.isShow = true ; return}  



         // if(this.$router.history.current.params.id == item.id) {return}

          this.$router.push({name: item.path, 
          params: {
            id: item.id, 
            json: item.json, 
            image: item.image}
            },() => {});
      }
    },
    mounted(){
    /*
        console.log("this.$router.history.current.params.id" , this.$router.history.current.params.id)

        const item = _.find(this.level0[1].level1, ['id', this.$router.history.current.params.id]) 
console.log("item: ", item)
this.loadGenitem(item)*/
    }
    
}
    
</script>

<style lang="scss">

//@import "@/assets/css/textcommons.scss";
@import "@/assets/css/_variables.scss";

#genesis-menu {
    position:fixed;
    top: 0px;
    left: -800px;
    width: 400px;
    //height: calc(100% - 120px);
    height: 100%;
    overflow-y: scroll;
    transition: left .5s ease-out;
    background-color:white;
    border-right: 0.14rem solid #777;
    padding: 8px;
    padding-left: 20px;
    padding-top: 30px;
    padding-right: 20px;
    z-index: 3;
    text-align:left;
    max-width: 450px;
    //width: 50%;
    margin: 0 auto;
    //padding: 30px 20px 8px 20px;

   // border-right: 1px solid #777;
    &.active{
        transition: left .3s ease-in;
        left: 0px;
    } 

    .closer {
      position: absolute;
      right: 0px;
      top: 0;
      cursor: pointer;
    }   

    ul {
      margin: 0;
      padding: 0;
      font-family: $font-family-herausgeber-medium;
      color: #000;
      //font-weight: 100;
      //font-weight: 100;
      font-size: 1.2rem;
      line-height: 1rem;
      padding-bottom: 8px;
      margin-right: 30px;
      //border-bottom: 0.15em solid #000000;     
    }


    ul {
        cursor: pointer;
        list-style: none;
        padding:0;
        li {
            border-bottom: 0.14rem solid  #777;;
            display: block;
            position: relative;
            //padding: 5px 0 5px 0;
            font-family: $font-family-herausgeber-medium;
            font-size: 1.2rem;
            line-height: 1.3rem;
            margin: 0;
            &.selected {
                color: red;
                >.mobile-nav-toggle .zf.zf-chevron-right {
                  background: url('~@/assets/icons/nextred.svg');
                }                
            }
            span.title {
                display: block;
                padding: 7px 0;
                max-width: calc(100% - 30px);
            }
            span.menuitem {
              display: block;
              padding: 5px 0;
              max-width: calc(100% - 30px);
            }

            .mobile-nav-toggle {
                font-size:20px;
                font-weight: bold;
                position: absolute;
                padding:6px;
                top: 5px;
                right: -35px;
                .zf {
                    width: 1rem;
                    height: 1rem;
                    display:block;                    
                    &.zf-chevron-right{      
                      transition: transform .5s;                
                      background: url('~@/assets/icons/nextgray.svg');
                    }
                    &.zf-chevron-right.active{      
                      transform: rotate(90deg);
                    }                    
                }
                
                &.active  {
                  .zf {                    
                    transform: rotate(90deg);
                  }
                }
              }
            }


            li > ul {margin:0; padding:0 ;  border-top: 0.1rem solid #777;}
            li > ul > li:first-child {border:0;}
            li > ul > li {
                font-family: $font-family-herausgeber-medium;
                font-size: 1rem;
                margin-left:20px;
                border-bottom:0;
                border-top: 0.1rem solid #777;
                color:#777;

            }
            li > ul > li > ul > li {
              font-family: $font-family-herausgeber-regular;
              
            }
        }
}




.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

</style>